/**
 * @license
 * Copyright Akveo. All Rights Reserved.
 * Licensed under the MIT License. See License.txt in the project root for license information.
 */
export const environment = {
  production: true,
  squareClientID: 'sq0idp-z_9crRDPDdENPa4i-zvRPw',
  squareBaseURL: 'https://connect.squareup.com',
};
